<style lang="less" scoped>
.cardList {position: relative;width: 776px;height: 206px;text-align: left;box-shadow: 2px 2px 5px rgba(0,0,0,0.5) !important;}
.header {height: 12px;}
.type {font-size: 18px;vertical-align: top;}
ul {list-style: none;}
.list span::before {content: "●";margin-right: 3px;}
li {margin-top: 10px;width: 240px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;float: left;}
li:hover {color: #13569e}
.list {margin-top: -10px;margin-left: -40px;}
</style>

<!--何宽  2021.6.3
    该卡片组件使用场景：在某个大标题下可以分为不同的小标题，每个小标题（以列表的形式）展示
    鼠标点击 更多 或者 小标题，将 相应的对象 传递给父组件 -->
<template>
  <el-card class="cardList">
    <div slot="header" class="header">
      <span class="type"> {{ this.type }} </span>
      <el-button style="float: right; padding: 3px 0" type="text" @click="getmore(button)">{{ this.button.value }}</el-button>
    </div>
    <ul class="list">
      <li v-for="(item, index) in listdata" :key="index">
        <span v-if="index < 12" @click="clickList(item)">{{ item.listTitle }}</span>
      </li>
    </ul>
  </el-card>
</template>

<script>
export default {
  props: ['cardList'],
  data()
  {
    return {
      type: '',
      button: '',
      listdata: []
    }
  },
  // 初始化
  created()
  {
    this.type = this.cardList.type
    this.button = this.cardList.button
    this.listdata = this.cardList.list
  },
  methods: {
    // 点击“更多”按钮，将该 button对象 传递给父组件
    getmore(button)
    {
      this.$emit('getmore', button)
    },
    // 点击列表项，并将选中的 li对象 传递给父组件
    clickList(item)
    {
      this.$emit('clickList', item)
    }
  }
}
</script>
<!--  父组件数据格式
list: [
    {
      type: '区域地质',
      button: {
        value: '更多',
        path: ''
      },
      list: [
        {
          listTitle: '地质勘查新技术-地球物理找矿法地质勘查新技术-地球物理找矿法',
          path: ''
        },
        {
          listTitle: '地质勘查新技术-地球化学找矿法地质勘查新技术',
          path: ''
        }
      ]
    }
  ]
-->



// WEBPACK FOOTER //
// src/plugins/app/assembly/CardList.vue